import { render } from "./ScannedBCList.vue?vue&type=template&id=5dd2a056&scoped=true"
import script from "./ScannedBCList.vue?vue&type=script&lang=ts"
export * from "./ScannedBCList.vue?vue&type=script&lang=ts"

import "./ScannedBCList.vue?vue&type=style&index=0&id=5dd2a056&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5dd2a056"

export default script